import {BrickContext, ActionBrick, registerBrick, QueryResult, ErrorFlow, Transaction, CloudObject, File} from 'olympe';
import { jsPDF } from 'jspdf';
import { binaryToDataUrl, getLogger } from '@olympeio/core'

export default class GeneratePDF extends ActionBrick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {Array} data
     * @param {Array} images
     * @param {File} template
     * @param {string} fileName
     * @param {function()} forwardEvent
     * @param {function(*)} setErrorFlow
     * @param {function(File)} setPDF
     */
    async update($, [data, images, template, fileName], [forwardEvent, setErrorFlow, setPDF]) {

        // process inputs to CSV data
        if (!(data instanceof Array) && !(data instanceof QueryResult)) {
            const message = 'Data input seems invalid.';
            getLogger('GeneratePDF').error(message);
            setErrorFlow(ErrorFlow.create(message, 1));
            return;
        }

        // generate the PDF
        await this.createPDFFromTemplate(
            data,
            template,
            images ?? [],
            (err) => {
                getLogger('GeneratePDF').error(err);
                setErrorFlow(ErrorFlow.create(err, 2));
            },
            (pdfBinary) => {

                // create the dile in DC
                const transaction = Transaction.from($);
                if (!fileName) {
                    fileName = 'PDF_generated_on_' + (new Date().toISOString()) + '.pdf';
                }
                const fileTag = File.createFromContent(transaction, fileName, pdfBinary, 'application/pdf');

                Transaction.process($, transaction)
                    .then(() => {
                        setPDF(CloudObject.get(fileTag));
                        forwardEvent();
                    }).catch((message) => {
                        getLogger('GeneratePDF').error(message);
                        setErrorFlow(ErrorFlow.create(message, 3));
                    });
            }
        );
    }


    /**
     * Generate a PDF from a template and set of data.
     *
     * @public
     * @param {Array} data
     * @param {File=} template
     * @param {Array=} files
     * @param {function(string)} onFail
     * @param {function(ArrayBuffer)} onSuccess
     */
    async createPDFFromTemplate(data, template, files, onFail, onSuccess) {
        const filesData = [];
        let templateCode;

        // fetch template
        try {
            templateCode = await template.getContentAsString();
        } catch (error) {
            onFail('Template not found: ' + error);
            return;
        }

        // fetch images
        for (const file of files) {
            if (file !== null) {
                try {
                    const data = await file.getContentUrl();
                    filesData.push({
                        'name': file.getProperty(File.fileNameProp),
                        'content': data
                    });
                } catch (error) {
                    onFail('Image not found: ' + error);
                    return;
                }
            } else {
                filesData.push(null);
            }
        }


        // render pdf: We want this try catch to avoid crashing of the whole app if the jspdf lib fails
        try {
            const Call_Template = new Function('jsPDF', templateCode);
            const PDF_template = Call_Template(jsPDF);
            // Arguments must correspond to those in template's render() function
            PDF_template['render'](
                data,
                filesData,
                onSuccess
            );
        } catch(error) {
            onFail('error when executing template: '+ error.message)
        }
    }

}

registerBrick('019086cc1876f494f3df', GeneratePDF);
